'use strict';

const $ = require('jquery');

class Popup {

    constructor() {

        require('./../../../../build/node_modules/@components/magnific-popup/dist/jquery.magnific-popup.js');

        $('[data-popup="video"]').magnificPopup({
            disableOn: 600,
            type: 'iframe',
            closeMarkup: '<span title="%title%" class="mfp-close">&#215;</span>'
        });

        $('[data-popup="image"]').magnificPopup({
            type: 'image',
            image: {
                verticalFit: true
            },
            closeMarkup: '<span title="%title%" class="mfp-close">&#215;</span>'
        });

        $('[data-popup="form"]').on('click', function (event) {
            event.preventDefault();

            let $this = $(this);

            let fileType = $this.data('popup-filetype');
            let brandID = $this.data('popup-brand-id');
            let productSheet = $this.data('popup-product-sheet');

            let $target = $this.attr('href');
            let $content = $($target).clone();

            if (fileType && brandID && productSheet) {
                $content
                    .attr('data-popup-brand-id', brandID)
                    .attr('data-popup-product-sheet', productSheet)
                    .find('[data-popup-filetype-holder]')
                    .html(fileType);
                
                $content.find('.product_sheet__brands select').val(brandID);

            }

            $.magnificPopup.open({
                items: {
                    src: $content,
                    type: 'inline'
                },
                callbacks: {
                    open: function () {

                        console.log('open callback');
                        App.Globals.$document.trigger('gform_post_render');
                    }
                }
            });

        });

    }

}

module.exports = Popup;
